import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MODULES, STICKY } from "../data/modules";
import { Reveal } from "./NoteBlocks";

const span = (id) => (id <= 2 ? "lg:col-span-2" : "");

const Card = ({ m, i }) => (
  <Reveal delay={(i % 4) * 0.06} className={`${span(m.id)} h-full`}>
    <motion.div whileHover={{ y: -6, rotate: i % 2 ? 0.8 : -0.8 }} transition={{ type: "spring", stiffness: 260, damping: 18 }} className="h-full">
      <Link to={`/module/${m.slug}`} className="board-card group" style={{ background: STICKY[m.color] }} data-testid={`module-card-${m.id}`}>
        <span className="pin" aria-hidden />
        <div className="flex items-start justify-between">
          <span className="font-display text-6xl sm:text-7xl leading-none text-[#1F2A44]/85">{String(m.id).padStart(2, "0")}</span>
          <ArrowUpRight className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </div>
        <h3 className={`font-semibold text-[#1F2A44] mt-6 ${m.id <= 2 ? "text-2xl sm:text-3xl" : "text-xl"}`}>{m.title}</h3>
        <p className="font-hand text-lg text-[#1F2A44]/80 mt-2 leading-snug">{m.tagline}</p>
        <p className="text-[14px] text-[#3A3A45] mt-4">{m.summary}</p>
      </Link>
    </motion.div>
  </Reveal>
);

export const ModuleBoard = () => (
  <section id="modules" className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="module-board">
    <Reveal>
      <p className="eyebrow">The syllabus</p>
      <h2 className="font-display text-6xl sm:text-7xl text-[#1F2A44] mt-3 leading-[0.9]">10 modules on one board.</h2>
      <p className="text-base md:text-lg text-[#4A4A55] max-w-xl mt-4">Start at 01 and go in order — each module builds on the last. Tap any note to open the full page.</p>
    </Reveal>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 mt-14">
      {MODULES.map((m, i) => <Card key={m.id} m={m} i={i} />)}
    </div>
  </section>
);
